import { User } from '../../shared/user/user.model';
import { SchoolService, School } from '.';

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { HttpResponse } from '@angular/common/http';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/merge';
import { FUZZY_SEARCH_DISTANCE } from '../../shared';

@Injectable()
export class SchoolTypeaheadService {

    // in milliseconds
    readonly DEBOUNCE_TIME = 300;

    constructor(private schoolService: SchoolService) {
    }

    resultFormatter = (school: any) => school['name'];

    inputFormatter = (school: any, p0: () => string) => {
        return school['name'];
    }

    searchWithCity(getCityId: () => string | number | null) {

        return (text$: Observable<string>) => text$
            .debounceTime(this.DEBOUNCE_TIME)
            .distinctUntilChanged()
            .switchMap(schoolTerm => {
                const cityTerm = 'city.id:' + getCityId();

                if (schoolTerm.length === 0 ) {
                    schoolTerm = ' ';
                }

                let formattedQuery = schoolTerm;
                if (schoolTerm) {
                    formattedQuery = schoolTerm.split(/[ ]+/).reduce((acumQuery, token) => {
                        let fuzzyToken =  token !== '' ? token + '~' + FUZZY_SEARCH_DISTANCE : '';
                        return acumQuery + ' ' + fuzzyToken;
                    }, '');
                }

                const finalQuery = formattedQuery.trim().length !== 0 ? cityTerm + ' AND ' + formattedQuery : ' ';

                return this.schoolService
                .searchNoAuth({ query: finalQuery  })
                .switchMap((res: HttpResponse<School[]>) => Observable.of(res.body));
            });
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/school/school.typeahead.service.ts